"use client";

import { useEffect, useRef, useState } from "react";
import { Box, Stack } from "@mui/material";
import { useSearchParams } from "next/navigation";

import Sidebar from "@/layout/sideBar";
import ChatContainer from "@/components/conversational/ChatContainer";
import ConversationalInputBox from "@/components/conversational/InputBox";
import NewConversationalLanding from "@/components/conversational/Landing";
import { useConversational } from "@/context/ConversationalContext";

function ConversationalPageInner() {
  const searchParams = useSearchParams();
  const urlSessionId = searchParams?.get("sid") ?? null;

  const {
    messages,
    setCurrentSessionId,
    isNewChat,
    loadMessages,
    messagesStatus,
    clearMessages,
  } = useConversational();

  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const lastUrlSessionIdRef = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    if (lastUrlSessionIdRef.current === urlSessionId) return;
    lastUrlSessionIdRef.current = urlSessionId;

    let cancelled = false;

    async function syncFromUrl() {
      if (!urlSessionId) {
        setCurrentSessionId(null);
        clearMessages();
        setIsHistoryLoading(false);
        isNewChat.current = true;
        return;
      }

      if (isNewChat.current) {
        setCurrentSessionId(urlSessionId);
        setIsHistoryLoading(false);
        return;
      }

      setIsHistoryLoading(true);
      setCurrentSessionId(urlSessionId);

      try {
        const maybePromise = loadMessages(urlSessionId);
        if (maybePromise && typeof (maybePromise as any).then === "function") {
          await maybePromise;
        }
      } finally {
        if (!cancelled) {
          setIsHistoryLoading(false);
        }
      }
    }

    // if (urlSessionId && !isNewChat.current) {
    //   isNewChat.current = false;
    // }

    void syncFromUrl();

    return () => {
      cancelled = true;
    };
  }, [urlSessionId, clearMessages, setCurrentSessionId, loadMessages]);


  const hasMessages = messages && messages.length > 0;

  const showHistoryLoader =
    (!!urlSessionId && isHistoryLoading && !hasMessages) ||
    messagesStatus === "loading";
  return (
    <Sidebar>
      <Stack
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          gap:  3,
        }}
      >
        {showHistoryLoader ? (
          <Box
            sx={{
              flex: 1,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Stack spacing={2} alignItems="center">
              <div className="loader"></div>
            </Stack>
          </Box>
        ) : !hasMessages ? (
          <NewConversationalLanding />
        ) : (
          <ChatContainer messages={messages as any} />
        )}

        <ConversationalInputBox />
      </Stack>
    </Sidebar>
  );
}

export default function Page() {
  return <ConversationalPageInner />;
}
